'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    text-overflow: ellipsis;\n'], ['\n    text-overflow: ellipsis;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    z-index: 2;\n    display: ', ';\n    position: absolute;\n    width: 100%;\n    margin-bottom: 50px;\n    box-sizing: border-box;\n    background: ', ';\n    border: 0;\n    box-shadow: 0 0 8px ', '1A;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    overflow: auto;\n\n    &::-webkit-scrollbar {\n        width: 8px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: ', ';\n        border-radius: ', ';\n\n        &:hover {\n            background: ', ';\n        }\n    }\n\n    &::after {\n        content: "";\n        padding: 4px;\n        height: 18px;\n        -webkit-box-sizing: border-box;\n        box-sizing: border-box;\n        text-align: right;\n        display: block;\n        background-image: url(https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3.png);\n        background-position: right;\n        background-repeat: no-repeat;\n        -webkit-background-size: 120px 14px;\n        background-size: 120px 14px;\n    }\n'], ['\n    z-index: 2;\n    display: ', ';\n    position: absolute;\n    width: 100%;\n    margin-bottom: 50px;\n    box-sizing: border-box;\n    background: ', ';\n    border: 0;\n    box-shadow: 0 0 8px ', '1A;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    overflow: auto;\n\n    &::-webkit-scrollbar {\n        width: 8px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: ', ';\n        border-radius: ', ';\n\n        &:hover {\n            background: ', ';\n        }\n    }\n\n    &::after {\n        content: "";\n        padding: 4px;\n        height: 18px;\n        -webkit-box-sizing: border-box;\n        box-sizing: border-box;\n        text-align: right;\n        display: block;\n        background-image: url(https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3.png);\n        background-position: right;\n        background-repeat: no-repeat;\n        -webkit-background-size: 120px 14px;\n        background-size: 120px 14px;\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    text-align: left;\n    cursor: pointer;\n    font-family: ', ';\n    font-weight: ', ';\n    font-size: ', ';\n    line-height: ', ';\n    letter-spacing: ', ';\n    color: ', ';\n    background: ', ';\n\n    &:last-child {\n        border-bottom-left-radius: 5px;\n        border-bottom-right-radius: 5px;\n    }\n\n    &:hover {\n        background: ', ';\n        color: ', ';\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    text-align: left;\n    cursor: pointer;\n    font-family: ', ';\n    font-weight: ', ';\n    font-size: ', ';\n    line-height: ', ';\n    letter-spacing: ', ';\n    color: ', ';\n    background: ', ';\n\n    &:last-child {\n        border-bottom-left-radius: 5px;\n        border-bottom-right-radius: 5px;\n    }\n\n    &:hover {\n        background: ', ';\n        color: ', ';\n    }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    width: 15px;\n    min-width: 15px;\n    height: 20px;\n    margin-right: 7px;\n    margin-top: 6px;\n    display: inline-block;\n    vertical-align: top;\n    background-position: -1px -161px;\n    background-image: url(https://maps.gstatic.com/mapfiles/api-3/images/autocomplete-icons.png);\n    -webkit-background-size: 34px 34px;\n    background-size: 34px;\n'], ['\n    width: 15px;\n    min-width: 15px;\n    height: 20px;\n    margin-right: 7px;\n    margin-top: 6px;\n    display: inline-block;\n    vertical-align: top;\n    background-position: -1px -161px;\n    background-image: url(https://maps.gstatic.com/mapfiles/api-3/images/autocomplete-icons.png);\n    -webkit-background-size: 34px 34px;\n    background-size: 34px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _input = require('../../atoms/input');

var _input2 = _interopRequireDefault(_input);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../constants/colors');

var _opacity = require('../../constants/opacity');

var _opacity2 = _interopRequireDefault(_opacity);

var _radius = require('../../constants/radius');

var _text = require('../../constants/text');

var _getColor = require('../../helpers/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var CustomPlaceAutocomplete = function CustomPlaceAutocomplete(_ref) {
	var selectedOption = _ref.selectedOption,
	    code = _ref.code,
	    label = _ref.label,
	    placeholder = _ref.placeholder,
	    top = _ref.top,
	    className = _ref.className,
	    error = _ref.error,
	    hideError = _ref.hideError,
	    disabled = _ref.disabled,
	    context = _ref.context,
	    handleOptionSelect = _ref.handleOptionSelect;

	var prevSearchTextRef = (0, _react.useRef)();
	var containerRef = (0, _react.useRef)(null);

	var _useState = (0, _react.useState)(null),
	    _useState2 = _slicedToArray(_useState, 2),
	    searchText = _useState2[0],
	    setSearchText = _useState2[1];

	var _useState3 = (0, _react.useState)(false),
	    _useState4 = _slicedToArray(_useState3, 2),
	    isOpened = _useState4[0],
	    setIsOpened = _useState4[1];

	var _useState5 = (0, _react.useState)([]),
	    _useState6 = _slicedToArray(_useState5, 2),
	    places = _useState6[0],
	    setPlaces = _useState6[1];

	var _useState7 = (0, _react.useState)(-1),
	    _useState8 = _slicedToArray(_useState7, 2),
	    selectedOptionIndex = _useState8[0],
	    setSelectedOptionIndex = _useState8[1];

	var _useState9 = (0, _react.useState)(null),
	    _useState10 = _slicedToArray(_useState9, 2),
	    fetchTimeout = _useState10[0],
	    setFetchTimeout = _useState10[1];

	var prevSearchText = prevSearchTextRef.current;

	var fetchData = function () {
		var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
			var response, data;
			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.prev = 0;
							_context.next = 3;
							return fetch(context.configuration.customPlacesAutoCompleteUri + '/api/place/autocomplete/' + code, {
								method: 'POST',
								credentials: 'same-origin',
								headers: {
									'Accept': 'application/json',
									'Content-Type': 'application/json',
									'Cache-Control': 'no-cache'
								},
								body: JSON.stringify({ keywords: searchText })
							});

						case 3:
							response = _context.sent;

							if (response.ok) {
								_context.next = 6;
								break;
							}

							throw new Error('HTTP error! status: ' + response.status);

						case 6:
							_context.next = 8;
							return response.json();

						case 8:
							data = _context.sent;

							setPlaces(data.places);
							_context.next = 15;
							break;

						case 12:
							_context.prev = 12;
							_context.t0 = _context['catch'](0);

							console.error('An error occurred while fetching the data.', _context.t0);

						case 15:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, undefined, [[0, 12]]);
		}));

		return function fetchData() {
			return _ref2.apply(this, arguments);
		};
	}();

	(0, _react.useEffect)(function () {
		var handleClickOutside = function handleClickOutside(event) {
			if (containerRef.current && !containerRef.current.contains(event.target)) setIsOpened(false);
		};

		var handleClickInside = function handleClickInside() {
			if (isOpened) return;
			if (places.length > 0) setIsOpened(true);
		};

		var handleKeyDown = function handleKeyDown(event) {
			if (event.key === 'Escape') setIsOpened(false);
		};

		document.addEventListener('mousedown', handleClickOutside);
		document.addEventListener('keydown', handleKeyDown);
		containerRef.current.addEventListener('mousedown', handleClickInside);

		return function () {
			return document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [containerRef]);

	(0, _react.useEffect)(function () {
		var handleKeyDown = function handleKeyDown(event) {
			switch (event.key) {
				case 'Escape':
					setIsOpened(false);
					break;
				case 'ArrowDown':
					event.preventDefault();
					setSelectedOptionIndex(function (prevIndex) {
						return (prevIndex + 1) % places.length;
					});
					break;
				case 'ArrowUp':
					event.preventDefault();
					setSelectedOptionIndex(function (prevIndex) {
						return (prevIndex - 1 + places.length) % places.length;
					});
					break;
				case 'Enter':
				case ' ':
					if (selectedOptionIndex > -1) {
						handleSelect(places[selectedOptionIndex]);
					}
					break;
				default:
					break;
			}
		};

		document.addEventListener('keydown', handleKeyDown);

		return function () {
			return document.removeEventListener('keydown', handleKeyDown);
		};
	}, [containerRef, isOpened, places, selectedOptionIndex]);

	(0, _react.useEffect)(function () {
		prevSearchTextRef.current = searchText;
		setIsOpened(places.length > 0);
	}, [places]);

	var handleClickInside = function handleClickInside() {
		if (isOpened) return;
		if (places.length > 0) setIsOpened(true);
	};

	var handleChange = function handleChange(value) {
		setSearchText(value);
		if (value === '') {
			handleClear();
		} else if (value && value.length > 2 && value !== prevSearchText) {
			if (fetchTimeout) clearTimeout(fetchTimeout);
			setFetchTimeout(setTimeout(fetchData, 500));
		}
	};

	var handleSelect = function handleSelect(option) {
		setIsOpened(false);
		setSearchText(null);
		setSelectedOptionIndex(-1);
		handleOptionSelect(option);
	};

	var handleClear = function handleClear() {
		setSearchText(null);
		setIsOpened(false);
		handleOptionSelect('');
	};

	var value = null;
	if (selectedOption && places.length > 0) {
		var foundPlace = places.find(function (p) {
			return p.placeId === selectedOption;
		});
		if (foundPlace) {
			value = foundPlace.placeText;
		}
	}

	return _react2.default.createElement(
		ComponentContainer,
		{ ref: containerRef,
			handleClickInside: handleClickInside
		},
		_react2.default.createElement(InputRequest, { value: searchText || value,
			label: label,
			placeholder: placeholder,
			changeEvent: handleChange,
			top: top,
			className: className,
			error: error,
			errorLabel: !hideError,
			disabled: disabled
		}),
		isOpened && _react2.default.createElement(
			OptionsList,
			{ isOpened: isOpened },
			places.map(function (option, index) {
				return _react2.default.createElement(
					OptionElement,
					{ key: option.placeId,
						onMouseDown: function onMouseDown() {
							return handleSelect(option);
						},
						selected: index === selectedOptionIndex
					},
					_react2.default.createElement(PacIcon, null),
					option.placeText
				);
			})
		)
	);
};

exports.default = CustomPlaceAutocomplete;


CustomPlaceAutocomplete.propTypes = {
	selectedOption: _propTypes2.default.string,
	code: _propTypes2.default.string.isRequired,
	label: _propTypes2.default.string,
	placeholder: _propTypes2.default.string,
	top: _propTypes2.default.number,
	className: _propTypes2.default.string,
	error: _propTypes2.default.string,
	hideError: _propTypes2.default.bool,
	disabled: _propTypes2.default.bool,
	context: _propTypes2.default.object.isRequired,
	handleOptionSelect: _propTypes2.default.func
};

var ComponentContainer = (0, _react.forwardRef)(function (props, ref) {
	return _react2.default.createElement(
		'div',
		{ ref: ref // NOSONAR
			, onClick: props.handleClickInside,
			onKeyDown: function onKeyDown(event) {
				if (event.key === 'Enter' || event.key === ' ') props.handleClickInside();
			},
			role: 'button',
			tabIndex: '0',
			'aria-pressed': 'false',
			style: { position: 'relative' }
		},
		props.children
	);
});

ComponentContainer.propTypes = {
	handleClickInside: _propTypes2.default.func,
	children: _propTypes2.default.node
};

var InputRequest = (0, _styledComponents2.default)(_input2.default)(_templateObject);

var OptionsList = _styledComponents2.default.div(_templateObject2, function (_ref3) {
	var isOpened = _ref3.isOpened;
	return isOpened ? 'block' : 'none';
}, _colors.Colors.LightMode, _colors.Colors.PrimaryText, (0, _getColor2.default)(_colors.Colors.Secondary, _opacity2.default.Medium), _radius.Radius.large, (0, _getColor2.default)(_colors.Colors.Secondary, _opacity2.default.Dark));

var OptionElement = _styledComponents2.default.a(_templateObject3, _text.TextSizes.ParagraphFontFamily, _text.TextSizes.WeightNormal, _text.TextSizes.P2FontSize, _text.TextSizes.P2LineHeight, _text.TextSizes.ParagraphLetterSpacing, function (_ref4) {
	var disabled = _ref4.disabled,
	    error = _ref4.error,
	    selected = _ref4.selected;

	if (disabled) return _colors.Colors.StrokeVeryDark;
	if (error) return _colors.Colors.Error;
	if (selected) return _colors.Colors.Secondary;
	return _colors.Colors.PrimaryText;
}, function (_ref5) {
	var selected = _ref5.selected;

	return selected ? (0, _getColor2.default)(_colors.Colors.Secondary, _opacity2.default.VeryLight) : '';
}, (0, _getColor2.default)(_colors.Colors.Secondary, _opacity2.default.VeryLight), _colors.Colors.Secondary);

var PacIcon = _styledComponents2.default.span(_templateObject4);